<template>
  <Modal
    class="cc-modal"
    width="500"
    footer-hide
    v-model="visibility"
    title="修改密码"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="bj-rows">
          <div class="name">原密码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            type="password"
            v-model="form.oldPwd"
            placeholder="请输入原密码"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="bj-rows">
          <div class="name">新密码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.newPwd"
            type="password"
            placeholder="请输入新密码"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="bj-rows">
          <div class="name">再次输入新密码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.confirmPwd"
            type="password"
            placeholder="再次输入新密码"
            style="width: 250px"
            clearable
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Button :loading="loading" @click="onConfirm" class="modal-confirm" style="margin-right: 20px">确定</Button>
      <Button @click="onCancel" class="modal-cancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userPwdUpdate } from "api/user.js";
import { mapMutations } from "vuex";
import { getEncrypt } from "utils/encrypt";
import loading from "components/loading.vue";
export default {
  name: "updatePasswordModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.oldPwd) {
        this.$Message.warning("请输入原密码！");
        return;
      }
      if (!this.form.newPwd) {
        this.$Message.warning("请输入新密码！");
        return;
      }
      if (!this.form.confirmPwd) {
        this.$Message.warning("请输入确认密码！");
        return;
      }
      if (this.form.newPwd !== this.form.confirmPwd) {
        this.$Message.warning("两次新密码输入不一致！");
        return;
      }
      this.loading = true;
      let newPwd = getEncrypt(this.form.newPwd);
      try {
        const params = {
          ymm: getEncrypt(this.form.oldPwd),
          xmm: newPwd,
          qrmm: newPwd,
        };
        const res = await userPwdUpdate(params);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("修改成功,请重新登录！");
              this.MUT_TOKEN_INFO(null);
              window.location.reload();
              localStorage.removeItem("vuex");
              localStorage.setItem("U_Secret",'');
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .section{
    padding: 30px 0;
  }
  .bj-rows{
    height: 45px;
    line-height: 45px;
    margin-bottom: 10px;
  }
  .name {
    color: #333333;
    font-size: 16px;
    min-width: 140px;
    text-align: right;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: center;
  }

</style>
